import apiClient from './api';

/**
 * PayPal.me Namensvalidierung API
 */
export const paypalApi = {
  /**
   * Validiert einen PayPal.me Namen
   * @param {string} paypalMeName - Der PayPal.me Name
   * @returns {Promise<Object>} - { success: boolean, data?: Object, error?: string }
   */
  async validatePayPalMeName(paypalMeName) {
    try {
      const response = await apiClient.post('/paypal/validate', {
        paypalMeName
      });
      
      return response.data;
    } catch (error) {
      console.error('PayPal.me Validierungsfehler:', error);
      
      if (error.response?.data) {
        return error.response.data;
      }
      
      return {
        success: false,
        error: 'Netzwerkfehler bei der PayPal.me Validierung'
      };
    }
  }
}; 